import React, { memo, forwardRef } from "react";
const SvgAngle = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M16.65 8.24a1 1 0 00-1.41.11l-12 14A1 1 0 004 24h12a1 1 0 100-2H6.174L16.76 9.65a1 1 0 00-.108-1.41z"
        clipRule="evenodd"
      />
      <rect width={10} height={14} x={20} y={9} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgAngle.displayName = "SvgAngle";
const MemoForwardRef = memo(SvgAngle);
export default MemoForwardRef;
